import { ObjectValues } from 'types';

export const COLOR_VARIANT = {
  BLUE: 'blue',
  BLUE_GREY: 'blue-grey',
  LIGHT_GREEN: 'light-green',
  GREEN: 'green',
  GREEN_FULL: 'green-full',
  DARK_GREEN: 'dark-green',
  DARK_GREEN_FULL: 'dark-green-full',
  ORANGE: 'orange',
  RED: 'red',
  GREY: 'grey',
  YELLOW: 'yellow',
  LIGHT_GREY: 'light-grey',
  WHITE: 'white',
  SILVER: 'silver',
  TRANSPARENT: 'transparent',
  RED_FULL: 'red-full',
  ORANGE_FULL: 'orange-full',
  PRIMARY: 'primary',
} as const;

export type ColorVariants = ObjectValues<typeof COLOR_VARIANT>;
